import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  // 14 minutes and 50 seconds in seconds
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 50);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  return <div className="flex items-center space-x-2 font-bold text-xl md:text-2xl text-white bg-red-700 px-4 py-1 rounded shadow-inner animate-pulse" data-id="element-253">
      <Clock className="w-5 h-5 md:w-6 md:h-6" data-id="element-254" />
      <span data-id="element-255">{formatTime(timeLeft)}</span>
    </div>;
}